/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './external-ad-unit-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-external-ad-unit-list-page',
  template
})
export class ExternalAdUnitListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.inv.external-ad-units.external-ad-unit';
  readonly demandSourceStateName = 'app.adm.external-demand-sources.external-demand-source';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: '', label: 'externalDemandSource', sortable: false},
    {param: 'externalSiteId'},
    {param: 'externalAdUnitId'},
    {param: 'externalAdType'},
    {param: 'width', label: 'dimensions'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
